import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCoiSQ3ij3otFy_p8jhGo5g3G-MBhbTBlU",
  authDomain: "wmc-site-96d37.firebaseapp.com",
  projectId: "wmc-site-96d37",
  storageBucket: "wmc-site-96d37.firebasestorage.app",
  messagingSenderId: "585811776326",
  appId: "1:585811776326:web:3f10fab4bb7a2341e4cb47",
  measurementId: "G-D1255J98Z6"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);